import { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  change?: {
    value: number;
    isPositive: boolean;
  };
  className?: string;
}

const StatCard = ({ title, value, icon, change, className = '' }: StatCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={`rounded-lg border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-700 dark:bg-gray-800 ${className}`}
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-500 dark:text-gray-400">{title}</p>
          <h3 className="mt-2 text-3xl font-semibold tracking-tight text-gray-900 dark:text-white">{value}</h3>
          
          {change && (
            <p className="mt-1 flex items-center text-xs font-medium">
              <span
                className={change.isPositive ? 'text-success-600 dark:text-success-400' : 'text-error-600 dark:text-error-400'}
              >
                {change.isPositive ? '+' : ''}{change.value}%
              </span>
              <span className="ml-1 text-gray-500 dark:text-gray-400">vs. last month</span>
            </p>
          )}
        </div>
        <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-600 dark:bg-primary-900/50 dark:text-primary-400">
          {icon}
        </div>
      </div>
    </motion.div>
  );
};

export default StatCard;